import { AfterViewInit, Component } from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import HighchartsSunburst from 'highcharts/modules/sunburst';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomServiceService } from '../../service/custom-service.service';
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { TranslateService } from '@ngx-translate/core';
HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);
HighchartsSunburst(Highcharts);

@Component({
  selector: 'app-coarse',
  templateUrl: './coarse.component.html',
  styleUrls: ['./coarse.component.css']
})
export class CoarseComponent implements AfterViewInit {
  selectedCommodity: string = ''; 
  selectedYear: any ='';
 // selectedCommodity: string = 'JOWAR';
 // selectedGraphCommodity: string = 'JOWAR';
  selectedGraphCommodity: string = '';
  january: any ='';
  february: any ='';
  march: any ='';
  april: any ='';
  may: any ='';
  june: any ='';
  july: any ='';
  august: any ='';
  september: any ='';
  october: any ='';
  november: any ='';
  december: any ='';
  totalCount: any ='';
  ShowCoarseTabView : boolean =false;
  ShowTabView : boolean =false;
  

  Toggle(boolean: boolean){
    this.ShowTabView = boolean;
    $('.Toggle').removeClass('active');
    if(boolean){
      $('#coarsechart').addClass('active');
    } else {
      $('#coarsetbl').addClass('active');
    }
  }


  public ngAfterViewInit(): void {
    this.createChartColumn();
  }
  

constructor(private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute,private router: ActivatedRoute,private encDec: EncryptDecryptService,private route: Router,private httpservice: CustomServiceService,public translate: TranslateService) {
    //code
};
start:number=0;
limit:number=10;
currentPage:number = 1;
totalRecords:number=0;
ProccoarseData: any=[];
language:any=sessionStorage.getItem('locale');;
  ngOnInit(): void {
    this.selectedYear = this.getCurrentFinancialYear();
    this.getCoarseProcListing('',this.selectedYear,'',this.start,this.limit,this.currentPage,'');
    this.generateFinancialYears();
  }
  financialYears: any = [];  
  private getRandomNumber(min: number, max: number, total: number): number {
    return Math.floor(total)
  }
  getCurrentFinancialYear(): string {
    const currentDate = new Date();
    const financialYearStart = new Date(currentDate.getFullYear(), 3, 1); // Assuming a financial year starting on April 1
  
    if (currentDate < financialYearStart) {
      return `${currentDate.getFullYear() - 1}-${currentDate.getFullYear()}`;
    } else {
      return `${currentDate.getFullYear()}-${currentDate.getFullYear() + 1}`;
    }
  }
  generateFinancialYears() {
    const startYear = 2012;
    const endYear = new Date().getFullYear();
    for (let year = startYear; year <= endYear; year++) {
      const start = year;
      const end = year + 1;
      const financialYear = `${start}-${end}`;
      this.financialYears.push(financialYear);
    }

    this.financialYears.sort((k: any, v: any) => v.localeCompare(k)); 

  }
  apirespons:any;
  getCoarseProcListing(selectedCommodity:any,selectedYear:any,category:any,start:number,limit:number,currentPage:number,type:any){
    let param= {
      'selectedCommodity':selectedCommodity,
      'selectedYear':selectedYear,
      'type': type,
      
    }
    this.fciwebservice.getCoarseProcListing(param).subscribe((response:any) => {
      switch (response.type) { 
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.apirespons = response.body;
          let respData = this.apirespons.RESPONSE_DATA;
          let respToken = this.apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
          
             this.ProccoarseData = res.result;
            //  console.log(this.ProccoarseData);
             this.createChartColumn();
          
             if(res.result.length > 0){
              this.totalRecords = res.result;
             
              
            } else {
              this.totalRecords = 0;
            }
          } 
      }
    });
  }

  onCommoditySelected(): void {
    this.getCoarseProcListing(this.selectedCommodity,this.selectedYear,'',this.start,this.limit,this.currentPage,'');
  }
  
  onYearSelected(): void {
  
    this.getCoarseProcListing('',this.selectedYear,'',this.start,this.limit,this.currentPage,'');
  }
  
  onGraphCommoditySelected(): void {
    this.getCoarseProcListing(this.selectedGraphCommodity,this.selectedYear,'',this.start,this.limit,this.currentPage,1);
  }
  pageChanged(page: any) {
  
    let param_arr = []; 
    let category,fyear;
    category="";
    fyear="";
  
    this.currentPage=page;
    this.start=(this.currentPage - 1)*this.limit;
    this.getCoarseProcListing(this.selectedCommodity,this.selectedYear,'category',this.start,this.limit,this.currentPage,'');
  }
  

  


  public mapCoarseDataToCategories(stockData: any[]): number[] {  
    const categories = [
      "andhra_pradesh",
      "telangana",
      "bihar",
      "chhattisgarh",
      "gujarat",
      "haryana",
      "karnataka",
      "madhya_pradesh",
      "maharashtra",
      "rajasthan",
      "uttrakhand",
      "tamilnadu",
      "uttapradesh",
      "odisha",
    ];
    const amounts: number[] = new Array(categories.length).fill(0);
      // console.log(stockData);
      stockData.forEach((item) => {
        for (let i = 0; i < categories.length; i++) {
          amounts[i] += parseFloat(item[categories[i]]);
          // amounts.push(parseFloat(months[i]));
        }
      });
    return amounts;
  }

  // public  mapProcMonthData(stockData: any[]): any[] {
  //   // console.log(stockData);
  //     // const months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
  //     const months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
  //     const amounts: number[] = new Array(months.length).fill(0);
  //     // console.log(stockData);
  //     stockData.forEach((item) => {
  //       for (let i = 0; i < months.length; i++) {
  //         amounts[i] += parseFloat(item[months[i]]);
  //         // amounts.push(parseFloat(months[i]));
  //       }
  //     });
  //   // console.log(amounts);
  //     return amounts;
  //   }
  coarseAmount:any;
  private createChartColumn(): void {    
    this.coarseAmount = this.mapCoarseDataToCategories(this.ProccoarseData);
    
    let date = new Date();
    const data: any[] = [];
    const categories = [
        "Andhra Pradesh",
        "Telangana",
        "Bihar",
        "Chhattisgarh",
        "Gujarat",
        "Haryana",
        "Karnataka",
        "Madhya Pradesh",
        "Maharashtra",
        "Rajasthan",
        "Uttarakhand",
        "Tamil Nadu",        
        "Uttar Pradesh",
        "Odisha",
    ];
    for (let i = 0; i < categories.length; i++) {
      date.setDate(new Date().getDate() + i);
      data.push({
        name: `${date.getDate()}/${date.getMonth() + 1}`,
        y: this.getRandomNumber(0, 10000, this.coarseAmount[i]),
      });
    }

    const chart = Highcharts.chart('chart-coarse' as any, {
     
      title: {
        text: this.language === 'English' ? 'Coarse Grain' : 'मोटा अनाज'
      },
      chart: {
        type: 'column',
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      
      yAxis: {
        min: 0,
        title: undefined,
      },
      xAxis: {
        categories: this.language === 'English' ? ["Andhra Pradesh", "Telangana","Bihar",  "Chhattisgarh",  "Gujarat", "Haryana",  "Karnataka","Madhya Pradesh",  "Maharashtra",  "Rajasthan", "Uttrakhand", "Tamil Nadu", "Uttar Pradesh", "Odisha",] :[ "आंध्र प्रदेश","तेलंगाना","बिहार", "छत्तीसगढ़", "गुजरात", "हरियाणा", "कर्नाटक",   "मध्य प्रदेश", "महाराष्ट्र", "राजस्थान", "उत्तराखंड","तमिलनाडु",  "उत्तर प्रदेश","ओडिशा"],
      },
      tooltip: {
        headerFormat: ``,
        pointFormat: `<div>{series.name}: {point.y}</div>`,
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
        // bar: {
        //   dataLabels: {
        //     enabled: true,
        //   },
        // },
      },
      series: [{
        name: 'Total',
        data,
 color: '#006637'
      }],
    } as any);

    
  }




  countDecimals:any = (value:any):any =>{ 
    if ((value % 1) != 0) 
        return value.toString().split(".")[1].length;  
    return 0;
  };
  NumberFormart(num:any):any{
  if(num=='' || num==null){
    return 0;
  }
  if(parseFloat(num) <= 0){
    if(this.countDecimals(num) > 5){
      return parseFloat(num).toFixed(5);
    }
    return num;
  }
  if(parseFloat(num)){
    if(this.countDecimals(num) > 5){
      return parseFloat(num).toFixed(5);
    }
    return num;
  }
  return num;
  }






}


